/**
 * Updates given query string with new key/value pair.
 * Existing key is replaced.
 * The rest of query string is untouched.
 * @param existingQueryString Existing query string.
 * @param newKey New key to add/update.
 * @param newValue New key value.
 * @param isFirst Whether to put new key at the beggining of query string or at the end.
 * @returns Updated query string.
 */
export function updateQueryString(
    existingQueryString: string,
    newKey: string,
    newValue: string | undefined,
    isFirst: boolean,
): string {
    // NOTE: we cannot use URLSearchParams here, because it encodes values during serialization
    // which might not be nessesary. The idea is to keep original key/value pairs as is.
    const params = existingQueryString
        .replace(/^\?+/, "")
        .split("&")
        .filter((param) => param && !param.startsWith(`${newKey}=`));

    if (newValue) {
        if (isFirst) {
            params.unshift(`${newKey}=${encodeURIComponent(newValue)}`);
        } else {
            params.push(`${newKey}=${encodeURIComponent(newValue)}`);
        }
    }
    return params.join("&");
}

export function parseQueryString(str: string, queries: string[]): Record<string, string | null> {
    const urlSearchParams = new URLSearchParams(str);

    return Object.fromEntries(queries.map((query) => [query, urlSearchParams.get(query)]));
}
